import { render } from "./preview-invoice.vue?vue&type=template&id=6a1110d5"
import script from "./preview-invoice.vue?vue&type=script&lang=js"
export * from "./preview-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__